import { PropertyType } from '../models/propertyType.model';
import { ListItem } from '../models/ListItem';
import GenericService from './genericService';
import { httpService } from './httpService';

class PropertyTypeService extends GenericService<PropertyType, ListItem> {
  constructor() {
    super('/api/PropertyType');
  }
}

export const propertyTypeService = new PropertyTypeService();
